import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Button from "../Button";
import {
  PageHeader,
  MessageBox,
  BoxMessage,
  OrangeText,
  CloseCross,
  Spacer
} from "../MasterCss";
import { useTranslation, Trans } from "react-i18next";

import { ReactComponent as Paper } from "../../images/paper.svg";
import { ReactComponent as Apple } from "../../images/apple.svg";
import { ReactComponent as Shirt } from "../../images/shirt.svg";
import { ReactComponent as Walk } from "../../assets/walk.svg";
import { ReactComponent as DrinkCan } from "../../images/drinks-can.svg";
import { ReactComponent as PlasticBag } from "../../images/plastic-bag.svg";
import { ReactComponent as PlasticBottle } from "../../images/plastic-bottle.svg";
import { ReactComponent as TV } from "../../assets/tv.svg";
import { ReactComponent as Tap } from "../../assets/tap.svg";
import crossButton from "../../assets/x-button.svg";

const useMediaQuery = (query) => {
  const [matches, setMatches] = useState(false);

  useEffect(() => {
    const media = window.matchMedia(query);
    const updateMatch = () => setMatches(media.matches);
    updateMatch();
    media.addEventListener('change', updateMatch);
    return () => media.removeEventListener('change', updateMatch);
  }, [query]);

  return matches;
};


const FunFactsBox = styled.div`
  background-image: linear-gradient(#21b2d3, #7abefd);
  position: fixed;
  width: 90vw;
  height: 85vh;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  overflow-x: hidden;
  overflow-y: scroll;
  display: block;
  z-index: 3000;
  border-radius: 1em;
  border: 2px solid #08345C;
  filter: drop-shadow(4px 4px 4px #08345C);
  text-align: center;
  @media (max-width: 480px) {
    padding-bottom: 5.4vh;
    padding-top: env(safe-area-inset-top);
  }
`;

const FactList = styled.ul`
  display: flex;
  flex-direction: column;
  text-align: left;
  li {
    line-height: 1.5em;
  }
`;

const Flexy = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  flex-wrap: wrap;
  gap: 0.5rem;
  overflow: visible; /* ensure nothing is clipped */
`;

const HeaderWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
`;

const ExtLink = styled.a`
  color: #FF8A00;
`;

const FunFactsModal = ({ handleClose }) => {
  const { t } = useTranslation();

  const isMobile = useMediaQuery('(max-width: 768px)');
  const svgSize = isMobile ? '60px' : '150px';

  const renderList = (key) => {
    const items = t(key, { returnObjects: true });
    if (!Array.isArray(items)) return null;
    return items.map((item, index) => <li key={index}>{item}</li>);
  };


  const SVG_VIEWBOX = "0 0 120 120";

  return (
    <FunFactsBox>
      <HeaderWrapper>
        <PageHeader>{t('funFacts.title')}</PageHeader>
      </HeaderWrapper>

      <MessageBox primary>
        <BoxMessage>
          <p>{t('funFacts.intro.p1')}</p>
          <p>{t('funFacts.intro.p2')}</p>
          <p>
            <Trans
              i18nKey="funFacts.intro.p3"
              components={{ 0: <OrangeText />, 1: <OrangeText />, 2: <OrangeText /> }}
            />
          </p>
        </BoxMessage>
      </MessageBox>

      <MessageBox primary>
        <BoxMessage>
          <p><OrangeText>{t('funFacts.reduce.heading')}</OrangeText></p>
          <FactList>{renderList('funFacts.reduce.tips')}</FactList>
          <Flexy>
            <Walk width={svgSize}  height={svgSize}/>
            <Tap width={svgSize}  height={svgSize}/>
            <TV width={svgSize}  height={svgSize}/>
          </Flexy>
        </BoxMessage>
      </MessageBox>

      <MessageBox primary>
        <BoxMessage>
          <p><OrangeText>{t('funFacts.reuse.heading')}</OrangeText></p>
          <FactList>{renderList('funFacts.reuse.tips')}</FactList>
          <Flexy>
            <PlasticBag viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
            <Shirt viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
            <Paper viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
          </Flexy>
        </BoxMessage>
      </MessageBox>

      <MessageBox primary>
        <BoxMessage>
          <p><OrangeText>{t('funFacts.recycle.heading')}</OrangeText></p>
          <FactList>{renderList('funFacts.recycle.tips')}</FactList>
          <Flexy>
            <PlasticBottle viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
            <DrinkCan viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
            <Apple viewBox={SVG_VIEWBOX} width={svgSize} height={svgSize} />
          </Flexy>
        </BoxMessage>
      </MessageBox>

      <MessageBox primary>
        <BoxMessage>{t('funFacts.discover')}</BoxMessage>
      </MessageBox>

      <Button primary handleClick={handleClose} label={t('close')} />
      <Spacer />
    </FunFactsBox>
  );
};

export default FunFactsModal;